<template>
  <div class="AccountList">
    <!-- 搜索区域 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></sirui-search>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'ledgerStatus'">
              <p v-if="scope.row[item.field] == 0" class="color">{{
                $t('setAccount.accountList.createMedium')
              }}</p>
              <p v-else-if="scope.row[item.field] == 1">{{
                $t('setAccount.accountList.overMedium')
              }}</p>
            </span>
            <span v-else-if="item.field === 'ledgerType'">
              <p v-if="scope.row[item.field] == 'ZTLX01'">{{
                $t('setAccount.accountList.primaryLedger')
              }}</p>
              <p v-else-if="scope.row[item.field] == 'ZTLX02'">{{
                $t('setAccount.accountList.subsidiaryLedger')
              }}</p>
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SiruiTable from '@/components/SiruiTable';
  import SiruiSearch from '@/components/SiruiSearch';
  import API from '@/api/systemManage/accountManage';
  export default {
    name: 'AccountList',
    components: {
      SiruiTable,
      SiruiSearch,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'ledgerCode',
            name: this.$t('setAccount.accountList.ledgerCode'),
            type: 'input',
            placeholder: this.$t('setAccount.accountList.writeLedgerCode'),
          },
          {
            prop: 'legalEntityName',
            name: this.$t('setAccount.accountList.legalEntityName'),
            type: 'input',
            placeholder: this.$t('setAccount.accountList.writeLegalEntityName'),
          },
        ];
      },
    },
    data() {
      return {
        load: false,
        menuButtonList: [], //按钮
        query: {
          ledgerCode: null, //分类账代码
          legalEntityName: null, //法人主体名称
        },
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        columnList: [],
        columnListDefault: [
          { field: 'ledgerCode', title: 'setAccount.accountList.ledgerCode', visible: true },
          { field: 'ledgerType', title: 'setAccount.accountList.ledgerType', visible: true },
          {
            field: 'extendLedgerCode',
            title: 'setAccount.accountList.extendLedgerCode',
            visible: true,
          },
          {
            field: 'accountCalendarCode',
            title: 'setAccount.accountList.accountCalendarCode',
            visible: true,
          },
          { field: 'currencyName', title: 'setAccount.accountList.currencyName', visible: true },
          {
            field: 'accountChartCode',
            title: 'setAccount.accountList.accountChartCode',
            visible: true,
          },
          { field: 'ledgerStatus', title: 'setAccount.accountList.ledgerStatus', visible: true },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      getData() {
        const { ledgerCode, legalEntityName } = this.query;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ledgerCode, legalEntityName, pageNum, pageSize };
        this.load = true;
        this.$axios.post(API.GET_LIST_LEDGERS, params).then((res) => {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'add') {
          let val = {
            path: '/system/creatAccount',
            name: 'creatAccount',
            title: this.$t('setAccount.accountList.creatAccount'),
          };
          this.toRouter(val);
        }
      },
      //搜索
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getData();
      },
      //双击事件
      dblclickEvent(value) {
        let val = {
          path: '/system/viewAccount',
          name: 'viewAccount',
          title: this.$t('setAccount.accountList.viewAccount'),
        };
        let id = value.row.id;
        this.toRouter(val, id);
      },
      //路由跳转
      toRouter(val, value) {
        let path = {
          path: val.path,
          name: val.name,
          meta: {
            keepAlive: true,
            title: val.title,
          },
        };
        if (value) {
          path.query = { id: value };
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .AccountList .color {
    color: #0071fe;
  }
</style>
